import Config from "../../../../../shared/src/ranj/app/config/Config";
import MockApi from "../../../../../shared/src/ranj/equalture/platform/MockAPI";
import PlatformAPIEventType from "../../../../../shared/src/ranj/equalture/platform/PlatformAPIEventType";
import ProgressValue from "../../../../../shared/src/ranj/equalture/platform/ProgressValue";
import ScenarioState from "../core/model/ScenarioState";
import NGTConfigKey from "../ngt/base/NGTConfigKey";

export default class CollaborationMockAPI extends MockApi {
    constructor(config) {
        super(config);

        this._globalAppId = config.getValue(Config.APPID);
        this._scenarios = config.getValue(NGTConfigKey.SCENARIOS);
        this._availableEpisodeAppIds = this._loadAvailableEpisodeIds() ?? this._scenarios.map(s => this._episodeIdToFullAppId(s.scenarioID));
    }

    async getGlobalConfigurationAsync() {
        const configuration = await super.getGlobalConfigurationAsync();
        configuration.episodes = this._loadEpisodesStates();
        return configuration;
    }

    sendEventAsync(eventType, payload) {
        const episodeStates = this._loadEpisodesStates();
        // NB: handle expected behaviour of platform when a scenario start/ends
        switch (eventType) {
            case PlatformAPIEventType.PROGRESS:
                const episodeAppId = payload.app_id;
                const episodeState = episodeStates.find(s => s.id === episodeAppId);
                episodeState.state = payload.progress_value == ProgressValue.COMPLETED
                    ? ScenarioState.STATE_FINISHED
                    : ScenarioState.STATE_STARTED;
                this._saveEpisodesStates(episodeStates);
                break;
        }

        return super.sendEventAsync(eventType, payload);
    }

    /**
     * Debug method used to set a list of episode ids that are available. 
     * After calling this method, it is recommended to refresh the webpage to see its effect.
     * @param {string[]} episodeIds 
     */
    setMockEpisodesList(... episodeIds) {
        this._availableEpisodeAppIds = episodeIds.map(episodeId => this._episodeIdToFullAppId(episodeId));
        this._saveAvailableEpisodeIds(this._availableEpisodeAppIds);
    }

    _saveAvailableEpisodeIds(episodeIds) {
        const str = !episodeIds || episodeIds.length <= 0 ? "" : JSON.stringify(episodeIds);
        window.localStorage.setItem(`${this._globalAppId}.availableEpisodeIds`, str);
    }

    _loadAvailableEpisodeIds() {
        const str = window.localStorage.getItem(`${this._globalAppId}.availableEpisodeIds`);
        if (!str) {
            return null;
        }
        return JSON.parse(str);
    }

    _saveEpisodesStates(episodeStates) {
        const str = JSON.stringify(episodeStates);
        window.localStorage.setItem(`${this._globalAppId}.episodeStates`, str);
    }

    /**
     * 
     * @returns {{ id: string, state: string}[]}
     */
    _loadEpisodesStates() {
        const str = window.localStorage.getItem(`${this._globalAppId}.episodeStates`);
        let states;
        if (!str) {
            states = this._scenarios.map(scenario => ({
                id: this._episodeIdToFullAppId(scenario.scenarioID),
                state: ScenarioState.STATE_AVAILABLE,
            }));
        } else {
            states = JSON.parse(str);
        }

        // NB: if any - filter states based on mock available episode ids
        if (!!this._availableEpisodeAppIds && this._availableEpisodeAppIds.length > 0) {
            states = states.filter(s => this._availableEpisodeAppIds.includes(s.id));
        }

        return states;
    }

    _episodeIdToFullAppId(episodeId) {
        return `${this._globalAppId}.${episodeId}`;
    }
}